import React, { useEffect, useState } from 'react'
import { Autocomplete, Box, Button, FormControl, IconButton, Stack, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TextField } from '@mui/material'
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { RootState } from '../../../global/config/store'
import { useDispatch, useSelector } from 'react-redux'
import useDebounce from '../CreateAllocations/UseDebounce.tsx'
import { setSelectedClientGroup } from '../../../global/config/Reducer/clientSlice.ts'
import { setDate } from '../../../global/config/Reducer/dateSlice.ts'
import { ApiGetClientEntityByClientGroupId, ApiGetVenueList, ApiGetAllocationSummary, ApiGetVisitTimes, ApiAldiAllocationSummaryExcel } from '../../../apiService/Core/Apicall.tsx'
import { toast } from 'react-toastify'

function AllocationSummary() {

    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
    const dispatch = useDispatch()
    const [currentDate, setCurrentDate] = useState(new Date(selectedDateRedux))
    const [venueName, setVenueName] = useState([])
    const [venueNameValue, setVenueNameValue] = useState<any>(null)
    const [clientEntityList, setClientEntityList] = useState<any>([])
    const [clientEntityId, setClientEntityId] = useState<string | null>(null)
    const Clientlist = useSelector((state: RootState) => state.client.clientList)
    const [selectedClient, setSelectedClient] = useState<any>(null)
    const [ClientId, setClientId] = useState(null)
    const [venue, setVenue] = useState([])
    const debouncedClientEntityId = useDebounce(clientEntityId, 500)
    const [datalength, setdatalength] = useState<any>(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [allocationSummary, setAllocationSummary] = useState<any>()
    const [allocationFilteredSummary, setAllocationFilteredSummary] = useState<any>()
    const [allocationSummaryData, setAllocationSummaryData] = useState<any[]>([])
    const [visitTimeInfo, setVisitTimeInfo] = useState([]);
    const [visitTimeList, setVisitTimeList] = useState([]);

    const getVisitTimes = async () => {
        const res = await ApiGetVisitTimes();
        setVisitTimeList(res?.data || []);
    };

    useEffect(() => {
        getVisitTimes()
    }, [])


    useEffect(() => {
        if (Clientlist.length > 0) {
            const aldiClient = Clientlist.find((client: any) =>
                client.clientGroupName?.toLowerCase() === 'aldi'
            )
            if (aldiClient) {
                setSelectedClient(aldiClient)
                setClientId(aldiClient.clientGroupName)
                dispatch(setSelectedClientGroup(aldiClient))
            }
        }
    }, [Clientlist, dispatch])


    useEffect(() => {
        if (clientEntityId === null) {
            setVenueName([])
        }
    }, [clientEntityId])

    useEffect(() => {
        if (clientEntityList.length > 0) {
            const auditBusiness = clientEntityList.find((entity: any) =>
                entity.entityName?.toLowerCase() === 'audit'
            )
            if (auditBusiness) {
                setClientEntityId(auditBusiness.clientEntityId)
            }
        }
    }, [clientEntityList])


    useEffect(() => {
        // console.log("ClientId", ClientId)
        handleGetClientList()
    }, [ClientId])

    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`
        if (!ClientId) return
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            // console.log(res.data)
            setClientEntityList(res.data)
            // setClientEntityId(res.data[0].clientEntityId)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }
    const ApiCallGetVenueList = async (debouncedClientEntityId?: any) => {
        let data = `?offset=0&limit=500`
        if (clientEntityId) {
            data += `&clientEntityId=${clientEntityId}&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
        } else if (selectedClient) {
            data += `&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
        }
        const res = await ApiGetVenueList(data)
        setVenue(res?.data)
        const response = res?.data.map((item: any) => ({
            label: item.venueName,
            value: item.venueId,
            state: item.state,
            entityTypeName: item.entityTypeName
        }))
        setVenueName(response)
        // setVenueNameValue(response[0]?.value);
    }
    useEffect(() => {
        if (debouncedClientEntityId || selectedClient) {
            ApiCallGetVenueList(debouncedClientEntityId)
        } else {
            setVenueName([])
            setVenueNameValue(null)
        }
    }, [debouncedClientEntityId, selectedClient])

    const handlePrevMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1)
            const jobMonth = newDate.getMonth() + 1
            const jobYear = newDate.getFullYear()
            dispatch(setDate(newDate))
            return newDate
        })
    }

    const handleNextMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1)
            const jobMonth = newDate.getMonth() + 1
            const jobYear = newDate.getFullYear()
            dispatch(setDate(newDate))
            return newDate
        })
    }

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01")
        setCurrentDate(newDate)
        dispatch(setDate(event.target.value))
    }

    useEffect(() => {
        if (selectedDateRedux) {
            setCurrentDate(new Date(selectedDateRedux))
        }
    }, [selectedDateRedux])

    const formatDate = (date: Date) => {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`
    }

    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleGetAllocationSummary = async () => {
        try {
            const month = currentDate.getMonth() + 1;
            const year = currentDate.getFullYear();

            let query = `?offset=${page * rowsPerPage}&limit=${rowsPerPage}`
            if (venueNameValue) query += `&venueId=${venueNameValue}`;
            if (clientEntityId) query += `&clientEntityId=${clientEntityId}`
            if (month) query += `&jobMonth=${month}`;
            if (year) query += `&jobYear=${year}`;

            const response = await ApiGetAllocationSummary(query);
            setAllocationSummary(response.summary);
            setAllocationFilteredSummary(response.filterSummary);
            setAllocationSummaryData(response.data);
            setdatalength(response.total);
        } catch (error) {
            console.error("Error generating allocation summary.", error)
        }
    }

    useEffect(() => {
        handleGetAllocationSummary();
    }, [page, rowsPerPage, venueNameValue, clientEntityId, currentDate]);


    const handleDownloadExcel = async () => {
        try {
            const data = `?clientEntityId=${clientEntityId}&jobYear=${currentDate.getFullYear()}`
            const res = await ApiAldiAllocationSummaryExcel(data);
            // console.log("Trend Data Response", res)

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `ALDI-allocations-breakdown-${currentDate.getFullYear()}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error:any) {
            toast.error(error?.message)

        }
    }

    return (
        <Box sx={{ p: 4 }} style={{ background: "white" }}>
            <Stack spacing={3}>
                <Box sx={{ width: "100%" }}>
                    <h1 className="common-manage-h1 mt-0 col-6" style={{ textAlign: "end", marginLeft: "250px" }}>
                        Allocation Summary
                    </h1>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: 'center',
                            gap: 2,
                            marginTop: "23px",
                            flexWrap: "wrap",
                           
                            flexDirection: { xs: "column", sm: "column", md: "row" }
                        }}
                    >
                        <Stack direction={{ xs: "column", sm: "column", md: "row" }} sx={{ width: { xs: "100%", md: "auto" } }} spacing={2}>
                            <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                                <Autocomplete
                                    disabled={true}
                                    disablePortal
                                    id="mm-autocomplete"
                                    options={Clientlist}
                                    value={selectedClient}
                                    getOptionLabel={(option: any) => option?.clientGroupName}
                                    isOptionEqualToValue={(option: any, value: any) =>
                                        option.clientGroupDBName === value.clientGroupDBName
                                    }
                                    onChange={(event, newValue: any) => {
                                        // setSelectedClient(newValue)
                                        dispatch(setSelectedClientGroup(newValue))
                                        setClientId(newValue?.clientGroupName || null)
                                        if (!newValue || (selectedClient && newValue.clientGroupName !== selectedClient.clientGroupName)) {
                                            setClientEntityId(null)
                                            setVenueNameValue(null)
                                            setClientEntityList([])
                                        }
                                    }}
                                    defaultValue="mmcommon"
                                    renderInput={(params) => <TextField {...params} label="Select Client" />}
                                    size="small"
                                />
                            </FormControl>
                        </Stack>
                        <Stack direction={{ xs: "column", sm: "column", md: "row" }}  sx={{ width: { xs: "100%", md: "auto" } }} spacing={2}>
                            <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                                <Autocomplete
                                    disabled={true}
                                    disablePortal
                                    id="beacon-autocomplete"
                                    options={clientEntityList?.filter((item: any) => item.clientEntityId !== null)}
                                    getOptionLabel={(option) => option?.entityName || ""}
                                    onChange={(event, newValue: any) => {
                                        setClientEntityId(newValue?.clientEntityId || null)
                                        if (!newValue) {
                                            setVenueNameValue(null)
                                        }
                                    }}
                                    value={clientEntityList?.find((option: any) => option?.clientEntityId === clientEntityId) || null}
                                    renderInput={(params) => <TextField {...params} label="Select Business" />}
                                    size="small"
                                />
                            </FormControl>
                            <FormControl size="small" sx={{ width: { xs: "100%", md: 250 } }}>
                                <Autocomplete
                                    disablePortal
                                    id="mm-autocomplete"
                                    options={venueName}
                                    getOptionLabel={(option: any) => `${option?.label} (${option?.state}) (${option?.entityTypeName})`}
                                    value={venueName.find((option: any) => option.value === venueNameValue) || null}
                                    onChange={(event, newValue: any) => {
                                        setVenueNameValue(newValue?.value)
                                    }}
                                    defaultValue=""
                                    renderInput={(params) => <TextField {...params} label="Select Site" />}
                                    size="small"
                                />
                            </FormControl>
                        </Stack>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginLeft: "220px",
                                width: { xs: "100%", md: 180 }
                            }}
                        >
                            <IconButton onClick={handlePrevMonth}>
                                <ChevronLeftIcon />
                            </IconButton>
                            <Box sx={{ display: "flex", alignItems: "center", mx: 0 }}>
                                <input
                                    type="month"
                                    value={formatDate(currentDate)}
                                    onChange={handleDateChange}
                                    className="primary-color"
                                    style={{
                                        border: "none",
                                        background: "none",
                                        fontSize: "1.25rem",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        fontFamily: "inherit",
                                    }}
                                />
                            </Box>
                            <IconButton onClick={handleNextMonth}>
                                <ChevronRightIcon />
                            </IconButton>
                        </Box>
                        <Box className='d-flex justify-content-end' flex={1} sx={{ width: { xs: "100%", md: "auto" } }} >
                            <Button
                                className="action-button text-white  action-button--approve table-row-background"
                                onClick={() => handleDownloadExcel()}
                            >Download as Excel</Button>
                        </Box>
                    </Box>
                </Box>
            </Stack>
            <Box sx={{ width: '100%', marginTop: 5 }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#757b52' }}>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: "16%", textAlign: "center" }}></TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: "16%", textAlign: "center" }}>Total</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: "16%", textAlign: "center" }}>1 to 14</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: "16%", textAlign: "center" }}>15 to 28</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: "16%", textAlign: "center" }}>10AM to 2PM</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: "16%", textAlign: "center" }}>2PM to 8PM</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow sx={{ verticalAlign: "top" }}>
                            <TableCell sx={{ backgroundColor: '#757b52', color: '#fff', width: "16%", textAlign: "center" }}>Total Aldi allocation</TableCell>
                            <TableCell sx={{ width: "16%", textAlign: "center" }}>{allocationSummary?.totalAldiAllocation || "N/A"}</TableCell>
                            <TableCell sx={{ width: "16%", textAlign: "center" }}>
                                {allocationSummary?.total1To14 || "N/A"} (
                                {allocationSummary?.total1To14 && allocationSummary?.totalAldiAllocation
                                    ? ((allocationSummary.total1To14 / allocationSummary.totalAldiAllocation) * 100).toFixed(2)
                                    : "0.00"
                                }%
                                )
                            </TableCell>
                            <TableCell sx={{ width: "16%", textAlign: "center" }}>
                                {allocationSummary?.total15To28 || "N/A"} (
                                {allocationSummary?.total15To28 && allocationSummary?.totalAldiAllocation
                                    ? ((allocationSummary.total15To28 / allocationSummary.totalAldiAllocation) * 100).toFixed(2)
                                    : "0.00"
                                }%
                                )
                            </TableCell>
                            <TableCell sx={{ width: "16%", textAlign: "center" }}>
                                {allocationSummary?.total10AMTo2PM || "N/A"} (
                                {allocationSummary?.total10AMTo2PM && allocationSummary?.totalAldiAllocation
                                    ? ((allocationSummary.total10AMTo2PM / allocationSummary.totalAldiAllocation) * 100).toFixed(2)
                                    : "0.00"
                                }%
                                )
                            </TableCell>
                            <TableCell sx={{ width: "16%", textAlign: "center" }}>
                                {allocationSummary?.total2PMTo8PM || "N/A"} (
                                {allocationSummary?.total2PMTo8PM && allocationSummary?.totalAldiAllocation
                                    ? ((allocationSummary.total2PMTo8PM / allocationSummary.totalAldiAllocation) * 100).toFixed(2)
                                    : "0.00"
                                }%
                                )
                            </TableCell>
                        </TableRow>
                        <TableRow key={""} sx={{ verticalAlign: "top" }}>
                            <TableCell sx={{ backgroundColor: '#757b52', color: '#fff', width: "16%", textAlign: "center" }}>Filtered Aldi allocation</TableCell>
                            <TableCell sx={{ width: "16%", textAlign: "center" }}>{allocationFilteredSummary?.filteredTotalAldiAllocation || "N/A"}</TableCell>
                            <TableCell sx={{ width: "16%", textAlign: "center" }}>
                                {allocationFilteredSummary?.filtered1To14 || "N/A"} (
                                {allocationFilteredSummary?.filtered1To14 && allocationFilteredSummary?.filteredTotalAldiAllocation
                                    ? ((allocationFilteredSummary.filtered1To14 / allocationFilteredSummary.filteredTotalAldiAllocation) * 100).toFixed(2)
                                    : 0
                                }%
                                )
                            </TableCell>
                            <TableCell sx={{ width: "16%", textAlign: "center" }}>
                                {allocationFilteredSummary?.filtered15To28 || "N/A"} (
                                {allocationFilteredSummary?.filtered15To28 && allocationFilteredSummary?.filteredTotalAldiAllocation
                                    ? ((allocationFilteredSummary.filtered15To28 / allocationFilteredSummary.filteredTotalAldiAllocation) * 100).toFixed(2)
                                    : 0
                                }%
                                )
                            </TableCell>
                            <TableCell sx={{ width: "16%", textAlign: "center" }}>
                                {allocationFilteredSummary?.filtered10AMTo2PM || "N/A"} (
                                {allocationFilteredSummary?.filtered10AMTo2PM && allocationFilteredSummary?.filteredTotalAldiAllocation
                                    ? ((allocationFilteredSummary.filtered10AMTo2PM / allocationFilteredSummary.filteredTotalAldiAllocation) * 100).toFixed(2)
                                    : 0
                                }%
                                )
                            </TableCell>
                            <TableCell sx={{ width: "16%", textAlign: "center" }}>
                                {allocationFilteredSummary?.filtered2PMTo8PM || "N/A"} (
                                {allocationFilteredSummary?.filtered2PMTo8PM && allocationFilteredSummary?.filteredTotalAldiAllocation
                                    ? ((allocationFilteredSummary.filtered2PMTo8PM / allocationFilteredSummary.filteredTotalAldiAllocation) * 100).toFixed(2)
                                    : 0
                                }%
                                )
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Box>
            <Box sx={{ width: '100%', marginTop: 5 }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#757b52' }}>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Site Name</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Business Name</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Month</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Year</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Min Date</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Max Date</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Visit Time</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {allocationSummaryData?.length > 0 ? (
                            allocationSummaryData?.map((item: any, index: number) => (
                                <TableRow key={item?.allocationId || index} sx={{ verticalAlign: "top" }}>
                                    <TableCell>{item?.venueId?.venueName}</TableCell>
                                    <TableCell>{item?.clientEntityId?.entityName}</TableCell>
                                    <TableCell>
                                        {item?.jobMonth}
                                    </TableCell>
                                    <TableCell>
                                        {item?.jobYear}
                                    </TableCell>
                                    <TableCell>
                                        {item?.minDate}
                                    </TableCell>
                                    <TableCell>
                                        {item?.maxDate}
                                    </TableCell>
                                    <TableCell>
                                        {visitTimeList?.find(
                                            (it: any) => it?.visitTimeId == item?.visitTimeInformation
                                        )?.visitTimeInformation}
                                    </TableCell>
                                </TableRow>
                            ))) : (
                            <TableRow>
                                <TableCell colSpan={7} align="center">
                                    No Cancelled Allocations Found
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={datalength}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Box>
        </Box>
    )
}
export default AllocationSummary;